import CheckboxSVG from "../checkbox-icon";
import { StyledProductCardFeatures } from "./product-card-features.scss";

const ProductCardFeatures = ({ features }) => (
  <StyledProductCardFeatures className="product-card-features">
    <div className="divider" />
    <div className="features">
      <span>Popular features:</span>
      {features?.map(({ feature }) => (
        <div className="feature">
          <CheckboxSVG />
          {feature}
        </div>
      ))}
    </div>
  </StyledProductCardFeatures>
);

export default ProductCardFeatures;
